export const ADMINISTRATOR = 'Administrator';
export const SUPPORT = 'Support';
export const SUPER_MANAGER = 'SuperManager';
export const MANAGER = 'Manager';
export const USER = 'User';

export const VERSIONS_EDITOR_EMAIL_WHITELIST = new Set<string>([
  'p.zakharov@open-s.info',
  'a.burkov@open-s.info',
  'a.safin@open-s.info',
  'e.predkova@open-s.info',
  'a.polikanova@open-s.info',

  'p.zakharov@getit.rest',
  'a.burkov@getit.rest',
  'a.safin@getit.rest',
  'e.predkova@getit.rest',
  'a.polikanova@getit.rest',

  // 'a.petrov@open-s.info'
].map(e => e.toLowerCase().trim()));
